import { cn } from '~/shared/lib/utils'
import { Button } from '~/shared/ui/button'
import { Tooltip, TooltipContent, TooltipProvider, TooltipTrigger } from '~/shared/ui/tooltip'

interface GuardedActionButtonProps {
  enabled: boolean
  hint: string
  label: string
  busyLabel: string
  busy: boolean
  disabled: boolean
  variant: 'default' | 'brand' | 'secondary' | 'outline'
  onClick: () => void
  className?: string
}

/**
 * Renders an action button, or a disabled button with a tooltip hint when the
 * action is not available yet (e.g. publish requires a cover image).
 */
export function GuardedActionButton({
  enabled,
  hint,
  label,
  busyLabel,
  busy,
  disabled,
  variant,
  onClick,
  className,
}: GuardedActionButtonProps) {
  if (!enabled) {
    return (
      <TooltipProvider>
        <Tooltip>
          <TooltipTrigger asChild>
            <span className={cn(className && 'inline-flex', className)}>
              <Button
                type="button"
                variant={variant}
                className={cn(className && 'w-full')}
                disabled
              >
                {label}
              </Button>
            </span>
          </TooltipTrigger>
          <TooltipContent>
            <p>{hint}</p>
          </TooltipContent>
        </Tooltip>
      </TooltipProvider>
    )
  }

  return (
    <Button
      type="button"
      variant={variant}
      className={className}
      disabled={disabled}
      onClick={onClick}
    >
      {busy ? busyLabel : label}
    </Button>
  )
}
